
import IndividualNavbar from "../IndividualNavbar/IndividualNavbar";
import ParticipantsContent from "../ParticipantsContent/ParticipantsContent";
import styles from "./ParticipantListPage.module.css";

function ParticipantListPage() {
    return (

        <div className={styles.container}>
            <section>
                <IndividualNavbar />
            </section>
            <section id={styles['participants-content']}>
                <ParticipantsContent />
            </section>
        </div>
    )
}

export default ParticipantListPage;